import { useState, cloneElement, useRef } from 'react'
import { PropTypes } from 'prop-types'
import { useEffect } from 'react'

const Dropdown = ({ trigger, menu, classNames }) => {
	const [open, setOpen] = useState(false)
	const dropdownRef = useRef()
	const handleOpen = () => {
		setOpen(!open)
	}

	useEffect(() => {
		const handleClickOutside = (event) => {
			if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
				setOpen(false)
			}
		}
		// eslint-disable-next-line no-undef
		document.addEventListener('click', handleClickOutside, true)
		return () => {
			// eslint-disable-next-line no-undef
			document.removeEventListener('click', handleClickOutside, true)
		}
	}, [])

	return (
		<div className='dropdown' ref={dropdownRef}>
			{cloneElement(trigger, {
				onClick: handleOpen,
			})}
			{open ? (
				<div className={classNames?.container ? classNames.container : "dropdown-menu"}>
					{menu.map((menuItem, index) => (
						<div key={index} className={classNames?.item ? classNames.item : "dropdown-menu-item"}>
							{cloneElement(menuItem, {
								onClick: () => {
									menuItem.props.onClick && menuItem.props.onClick()

									setOpen(false)
								},
							})}
						</div>
					))}
				</div>
			) : null}
		</div>
	)
}

Dropdown.propTypes = {
	trigger: PropTypes.object,
	menu: PropTypes.array,
  classNames: PropTypes.object
}

export default Dropdown
